<!-- eslint-disable no-tabs -->
<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-database-plus"
      inline
      class="px-5 py-4 ml-0"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Importações de Dados
        </div>
      </template>
      <v-text-field
        id="importacao-dados-administracao-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto mt-4 break-search"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-divider class="mt-10" />
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search.sync="search"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma pré importação de Dados disponível"
      >
        <template v-slot:[`item.importacao_dados.status`]="{ item }">
          <general-status
            :status="item.importacao_dados.status"
            :progresso="progresso[item.importacao_dados.id]"
          />
        </template>
        <template v-slot:[`item.data`]="{ item }">
          {{item.importacao_dados.created | parseToDateTimeBR}}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="info"
            min-width="0"
            class="px-1 ml-n1"
            fab
            icon
            x-small
            @click="getImpoDetails(item.importacao_dados.id)"
          >
            <v-icon
              small
            >
              mdi-gesture-tap
            </v-icon>
          </v-btn>
          <v-btn
            id="action-log-importacao-dados-administracao"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            @click="dialogCreationLog = true, dialogCreationLogData = {username: item.usuario.nome, created: item.importacao_dados.created}"
	          >
	            <v-icon small> mdi-table-search</v-icon>
	          </v-btn>
	        </template>
	        <template v-slot:[`footer.page-text`]>
	          <v-tooltip bottom>
	            <template v-slot:activator="{ on, attrs }">
	              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('recharge')">mdi-refresh</v-icon>
	            </template>
	            <span>Clique aqui para recarregar as importações</span>
	          </v-tooltip>
	        </template>
	      </v-data-table>
    </base-material-card>
    <dialog-creation-log
      :dialog.sync="dialogCreationLog"
      :item="dialogCreationLogData"
    />
    <v-dialog
      v-model="dialogImpoDetails"
      max-width="450px"
    >
      <v-card>
        <v-card-title class="headline">
          Detalhes da Importação
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
										<tr>
											<td>
												Nº de linhas pré-importadas:
											</td>
											<td>
												{{ detalhes.pre_importacao_dados.total_linhas_inseridas }}
											</td>
										</tr>
										<tr>
											<td>
												Nº de registros inseridos:
											</td>
											<td>
												{{ detalhes.total_registros_inseridos }}
											</td>
										</tr>
										<tr>
											<td>
												Nº de registros atualizados:
											</td>
											<td>
												{{ detalhes.total_registros_atualizados }}
											</td>
										</tr>
										<tr>
											<td>
												Nº de registros ignorados:
											</td>
											<td>
												{{ detalhes.total_registros_ignorados }}
											</td>
										</tr>
										<tr>
											<td>
												Nº de linhas com erros:
											</td>
											<td>
												{{ detalhes.total_registros_erros }}
											</td>
										</tr>
										<tr>
											<td>
												Início do processamento:
											</td>
											<td>
												{{ formatarDataHoraDetalhe(detalhes.inicio_processamento_importacao) }}
											</td>
										</tr>
										<tr>
											<td>
												Final do processamento:
											</td>
											<td>
												{{ formatarDataHoraDetalhe(detalhes.fim_processamento_importacao) }}
											</td>
										</tr>
										<tr>
											<td>
												Logs do processamento:
											</td>
											<td>
													<v-btn
														v-if="detalhes.compactada"
													:loading="loadingDetalhes"
													:disabled="loadingDetalhes"
													color="primary"
													class="ma-2"
													@click="downloadFile(detalhes.id)"
												>
													Baixar Logs
													<v-icon
														right
														dark
													>
														mdi-download
													</v-icon>
												</v-btn>
											</td>
										</tr>
                  </tbody>
                </template>
              </v-simple-table>
						</v-col>
					<v-row>
						<v-col cols="12">
							<h3>Tabelas Ações</h3>
							<v-simple-table dense>
                <template v-slot:default>
                  <tbody>
											<tr v-for="(acao, key) in tabelasAcoesDetalhes" :key="key">
											<td>{{ acao.nome }}</td>
											<td>{{ acao.acao }}</td>
										</tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
					</v-row>
          </v-row>   
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            text
            @click="dialogImpoDetails=false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
  
  <script>
  import dayjs from "dayjs"
  import ImportacoesDadosService from "@/services/ImportacoesDadosService.js"
	import ArquivosDadosService from "@/services/ArquivosDadosService.js"

  export default {
    components:{
      DialogMapeamento: () => import('@/components/importacoesDados/administracao/DialogMapeamento.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
    },

    props: {
      items: {
        type: Array,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      progresso: {
        type: Object,
        default: () => ({}),
      },
    },

	    data: () => ({
				loadingDetalhes: false,
	      search: '',
				detalhes: [],
      selectedImpoId: null,
      dialogImpoDetails: false,
      dialogCreationLog: false,
      dialogCreationLogData: {},
      headers: [
        {
          text: '#',
          value: 'importacao_dados.id',
        },
        {
          text: 'Tipo',
          value: 'tipo_importacao_dados.descricao',
        },
        {
          text: 'Pré',
          value: 'id',
        },
        {
          text: 'Data',
          value: 'data',
        },
        {
          text: 'Status',
          value: 'importacao_dados.status',
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4',
        },
	      ],
	    }),

		computed: {
			tabelasAcoesDetalhes() {
				if (!this.detalhes || !this.detalhes.tabelas_acoes) return [];

				try {
					const acoes = JSON.parse(this.detalhes.tabelas_acoes);
					return acoes.reduce((normalizadas, acao) => {
						if (Object.prototype.hasOwnProperty.call(acao, 'nome')) {
							normalizadas.push({
								nome: acao.nome,
								acao: acao.acao,
							});
							return normalizadas;
						}

						Object.entries(acao).forEach(([nome, valor]) => {
							normalizadas.push({
								nome,
								acao: valor,
							});
						});
						return normalizadas;
					}, []);
				} catch (error) {
					return [];
				}
			},
		},
	
	    methods:{
			formatarDataHoraDetalhe(data) {
				if (!data || /^0000-00-00/.test(data)) return '-';

				const dataFormatada = dayjs(data);
				return dataFormatada.isValid() ? dataFormatada.format('DD/MM/YYYY HH:mm') : '-';
			},

      getImpoDetails(id) {
        this.selectedImpoId = id;
        ImportacoesDadosService.getImportacaoDetalhes(this.selectedImpoId)
        .then((resp) => {
					this.detalhes = resp.data.importacao
          this.dialogImpoDetails = true
        })
        .catch(() => { 
          this.$toast.error(`Erro ao buscar detalhes.`, '', {position: 'topRight'})
        });
      },

			downloadFile(id) {

				this.$toast.info('Preparando seu arquivo para download.', '',{ position:'topRight', timeout: 2000 });

				ImportacoesDadosService.downloadLog(id, {
					timeout: 60 * 60 * 1000,
					onDownloadProgress: (progressEvent) => {
						let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						let isComputable = progressEvent.lengthComputable;
					}
				})
					.then(res => {
						const url = window.URL.createObjectURL(new Blob([res.data]));
						const link = document.createElement("a");
						link.href = url;
						link.setAttribute("download", `importacao_${id}.zip`);
						document.body.appendChild(link);
						link.click();
					})
					.catch(err => {
						console.error(err);
						this.$toast.error(`Erro ao baixar logs da importação ${id}.`, "", { position: "topRight" });
					});
				}
    },
  }
  </script>
